/**
 * Hides a marker from the Google Map instance.
 *
 * @param marker - The Google Maps Marker to hide.
 */
export const hideMarker = ({ marker, }) => {
    marker?.setMap(null);
};
/**
 * Shows a marker on the Google Map instance.
 *
 * @param marker - The Google Maps Marker to show.
 * @param map - The Google Map instance to show the marker on.
 */
export const showMarker = ({ marker, map, }) => {
    marker?.setMap(map);
};
